/* ============================================================
   Bro Glo x Reading Royals landing page (Shopify)
   assets/royals-landing.js - loaded by the royals-* sections (runs once per page)

   CONFIG comes from Theme Editor settings via window.RoyalsConfig
   (printed by sections/royals-products.liquid from its Theme Editor settings). Defaults below match the approved mockup.
   ============================================================ */
(function(){
'use strict';
if (window.__royalsLanding) return;
window.__royalsLanding = true;
var CFG = window.RoyalsConfig || {};
var ROYALS = {
  storeUrl: '',                                  // relative links on the live store
  discountCode: CFG.discountCode || '',          // optional backup on cart links; never shown on the page
  utmDefaults: {
    utm_source: CFG.utmSource || 'reading_royals',
    utm_medium: CFG.utmMedium || 'arena_qr',
    utm_campaign: CFG.utmCampaign || 'royals_2627',
    utm_content: CFG.utmContent || 'concourse_video_v1'
  },
  shopAllPath: CFG.shopAllPath || '/collections/all'
};

/* ============================================================
   ANALYTICS HOOK - no library. Pushes to dataLayer (GTM / GA4)
   and fires a DOM event other tools can listen for.
   ============================================================ */
window.dataLayer = window.dataLayer || [];
function track(event, props){
  var payload = Object.assign({ event: event, campaign: 'royals_2627' }, UTM, props || {});
  window.dataLayer.push(payload);
  try { document.dispatchEvent(new CustomEvent('broglo:track', { detail: payload })); } catch(e){}
}

/* ============================================================
   UTM CAPTURE - URL first, then this session, then defaults.
   Persisted per session so UTMs survive a refresh or in-page nav.
   ============================================================ */
var UTM = (function(){
  var keys = ['utm_source','utm_medium','utm_campaign','utm_content'], out = {}, saved = {}, qs;
  try { qs = new URLSearchParams(location.search); } catch(e){ qs = { get: function(){ return null; } }; }
  try { saved = JSON.parse(sessionStorage.getItem('royals_utm') || '{}'); } catch(e){}
  keys.forEach(function(k){ out[k] = qs.get(k) || saved[k] || ROYALS.utmDefaults[k]; });
  try { sessionStorage.setItem('royals_utm', JSON.stringify(out)); } catch(e){}
  return out;
})();

/* ============================================================
   CART LINKS - Shopify cart permalinks keep UTMs, tag the order
   with cart attributes (visible on the order + in reports), and
   re-apply the discount code if the cookie was lost.
   Accepts one or many items: "VARIANT:QTY,VARIANT:QTY"
   ============================================================ */
function parseItems(str){
  return String(str || '').split(',').map(function(s){
    var p = s.trim().split(':'), id = p[0], qty = parseInt(p[1] || '1', 10);
    return /^\d+$/.test(id) && qty > 0 ? { id: id, qty: qty } : null;
  }).filter(Boolean);
}
function serializeItems(items){ return items.map(function(i){ return i.id + ':' + i.qty; }).join(','); }
function cartUrl(items){
  var list = typeof items === 'string' ? parseItems(items) : items;
  if (!list.length) return '#shop';
  var p = new URLSearchParams();
  Object.keys(UTM).forEach(function(k){ p.set(k, UTM[k]); });
  p.set('attributes[campaign]', 'royals_2627');
  p.set('attributes[royals_placement]', UTM.utm_content);
  if (ROYALS.discountCode) p.set('discount', ROYALS.discountCode);
  return ROYALS.storeUrl + '/cart/' + serializeItems(list) + '?' + p.toString();
}
function refreshCartLinks(){
  // Buy buttons are <button>s that add via the Cart API (below). Only real links get a permalink href.
  document.querySelectorAll('a.js-cart').forEach(function(a){ a.href = cartUrl(a.dataset.items); });
}

/* ============================================================
   ADD TO CART - Shopify AJAX Cart API
   The theme's cart drawer intercepts every link containing "/cart" and only
   opens the drawer, so buy buttons add items with POST /cart/add.js instead:
   1) add all items in data-items in ONE request (Body + Mitt = 2 variants)
   2) tag the cart with campaign attributes (for order attribution)
   3) then, per Theme Editor setting: open the cart drawer, go to checkout, or go to /cart
   ============================================================ */
function cartAttributes(){
  return { campaign: 'royals_2627', royals_placement: UTM.utm_content,
           utm_source: UTM.utm_source, utm_medium: UTM.utm_medium,
           utm_campaign: UTM.utm_campaign, utm_content: UTM.utm_content };
}
function postJSON(url, body){
  return fetch(url, { method: 'POST', credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify(body) }).then(function(r){
      return r.json().catch(function(){ return {}; }).then(function(j){ if (!r.ok) { var e = new Error(j.description || j.message || ('HTTP ' + r.status)); e.status = r.status; throw e; } return j; });
    });
}
function cartMessage(btn, text){
  var box = btn.parentNode.querySelector('.rl-cart-msg');
  if (!box){ box = document.createElement('p'); box.className = 'rl-cart-msg'; box.setAttribute('role','alert'); btn.parentNode.insertBefore(box, btn.nextSibling); }
  box.textContent = text; box.hidden = !text;
}
function afterAdd(){
  var mode = CFG.afterAdd || 'drawer';
  if (mode === 'checkout') { location.href = '/checkout' + (ROYALS.discountCode ? '?discount=' + encodeURIComponent(ROYALS.discountCode) : ''); return; }
  if (mode === 'drawer' && window.BWCart && typeof window.BWCart.refresh === 'function') { window.BWCart.refresh(true); return; }
  location.href = '/cart';
}
/* ============================================================
   BACK TO BAG - landing page only (the header is hidden here)
   Nothing shows until the visitor adds a product on THIS page.
   Then: mobile sticky bar -> bag bar; desktop -> bag pill (top right).
   Both reopen the theme's cart drawer (BWCart.open). Count/total come from /cart.js
   and re-sync whenever the drawer re-renders, so removing everything hides it again.
   ============================================================ */
var Bag = (function(){
  var KEY = 'royals_bag_on';
  var cfg = document.querySelector('.rl-bag-cfg');
  if (!cfg) return { added: function(){}, isOn: function(){ return false; } };
  var on = false, timer = null;
  function flag(v){ try { if (v) sessionStorage.setItem(KEY, '1'); else sessionStorage.removeItem(KEY); } catch(e){} }
  function flagged(){ try { return sessionStorage.getItem(KEY) === '1'; } catch(e){ return false; } }
  function fmt(cents){
    var f = cfg.getAttribute('data-money-format') || '${{amount}}';
    var n = (Number(cents) || 0) / 100;
    function grp(num, dec, t, d){ var p = num.toFixed(dec).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t); return p.join(d); }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function(m, k){
      if (k === 'amount_no_decimals') return grp(n, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return grp(n, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return grp(n, 0, '.', ',');
      if (k === 'amount_with_apostrophe_separator') return grp(n, 2, "'", '.');
      return grp(n, 2, ',', '.');
    });
  }
  function all(sel){ return Array.prototype.slice.call(document.querySelectorAll(sel)); }
  function render(cart){
    var n = (cart && cart.item_count) || 0;
    on = n > 0;
    if (!on) flag(false); else watch();
    var word = n === 1 ? (cfg.getAttribute('data-item-one') || 'item') : (cfg.getAttribute('data-item-many') || 'items');
    var total = fmt(cart && cart.total_price);
    all('.rl .js-bag-count').forEach(function(el){ el.textContent = n; });
    all('.rl .js-bag-items').forEach(function(el){ el.textContent = n + ' ' + word; });
    all('.rl .js-bag-total').forEach(function(el){ el.textContent = total; });
    var aria = (cfg.getAttribute('data-aria') || 'View bag, [count] [items], [total]')
      .replace('[count]', n).replace('[items]', word).replace('[total]', total);
    all('.rl .s-bag-open, .rl .bagpill').forEach(function(el){ el.setAttribute('aria-label', aria); });
    all('.rl .bagpill').forEach(function(el){
      el.classList.toggle('is-on', on);
      el.setAttribute('aria-hidden', on ? 'false' : 'true');
      el.tabIndex = on ? 0 : -1;
    });
    var bar = document.getElementById('sticky');
    if (bar && bar.querySelector('.s-bag')) bar.classList.toggle('is-bag', on);
    try { window.dispatchEvent(new Event('royals:bag')); } catch(e){}
  }
  function sync(){
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); }).then(render).catch(function(){});
  }
  function open(){
    var c = window.BWCart;
    if (c && typeof c.open === 'function') { c.open(); return; }
    if (c && typeof c.refresh === 'function') { c.refresh(true); return; }
    location.href = '/cart';
  }
  document.addEventListener('click', function(e){
    if (e.target.closest('.rl .js-bag-open')) { e.preventDefault(); open(); }
  });
  all('.rl .js-bag-checkout').forEach(function(a){
    a.href = '/checkout' + (ROYALS.discountCode ? '?discount=' + encodeURIComponent(ROYALS.discountCode) : '');
  });
  // The drawer re-renders its own markup after every change (qty, remove, discount). Re-sync then.
  var watched = false;
  function watch(){
    if (watched || !window.MutationObserver) return;
    var drawer = document.getElementById('BWCartDrawer'); if (!drawer) return;
    watched = true;
    new MutationObserver(function(){ if (!on) return; clearTimeout(timer); timer = setTimeout(sync, 250); })
      .observe(drawer, { childList: true });
  }
  watch();
  document.addEventListener('DOMContentLoaded', watch);
  window.addEventListener('load', watch);
  if (flagged()) sync();
  return {
    added: function(){ flag(true); sync(); },
    isOn: function(){ return on; }
  };
})();

document.addEventListener('click', function(e){
  var btn = e.target.closest('button.js-cart'); if (!btn) return;
  e.preventDefault();
  if (btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
  var items = parseItems(btn.dataset.items).map(function(i){ return { id: Number(i.id), quantity: i.qty }; });
  if (!items.length) return;
  var label = btn.innerHTML;
  btn.setAttribute('aria-busy','true'); btn.disabled = true;
  btn.textContent = CFG.addingText || 'Adding...';
  cartMessage(btn, '');
  postJSON('/cart/add.js', { items: items })
    .then(function(){ return postJSON('/cart/update.js', { attributes: cartAttributes() }).catch(function(){}); })
    .then(function(){
      track('add_to_cart', { product: btn.dataset.product || null, items: btn.dataset.items, item_count: items.length,
        royals_price: btn.dataset.royalsPrice ? Number(btn.dataset.royalsPrice) : null, position: btn.dataset.position || null });
      btn.innerHTML = label; btn.disabled = false; btn.removeAttribute('aria-busy');
      Bag.added();
      afterAdd();
    })
    .catch(function(err){
      btn.innerHTML = label; btn.disabled = false; btn.removeAttribute('aria-busy');
      cartMessage(btn, (err && err.status === 422 && err.message) ? err.message : (CFG.cartErrorText || "Couldn't add to cart. Try again."));
    });
});

/* Landing view */
track('royals_landing_view', { landing_path: location.pathname });

/* Shade toggles - swap the item in data-slot, update the CTA and any linked sticky CTA */
document.querySelectorAll('.shade').forEach(function(g){
  var card = g.closest('[data-product]'), product = card.dataset.product;
  var slot = parseInt(g.dataset.slot || '0', 10);
  g.addEventListener('click', function(e){
    var b = e.target.closest('button'); if(!b || b.disabled) return;
    g.querySelectorAll('button').forEach(function(x){ x.setAttribute('aria-pressed', x===b ? 'true' : 'false'); });
    var targets = [card.querySelector('.js-cart')].concat([].slice.call(document.querySelectorAll('[data-follow-shade="'+product+'"]')));
    targets.forEach(function(t){
      if(!t) return;
      var items = parseItems(t.dataset.items);
      if (items[slot]) { items[slot].id = b.dataset.variant; t.dataset.items = serializeItems(items); }
    });
    refreshCartLinks();
    track('shade_select', { product: product, variant_id: b.dataset.variant, shade: b.firstChild.textContent.trim() });
  });
});
refreshCartLinks();

/* Shop-all links: internal destination + campaign UTMs. No discount code here; the Royals code is
   already stored from the /discount/ entry URL and persists sitewide. */
function utmUrl(path){
  var p = new URLSearchParams();
  Object.keys(UTM).forEach(function(k){ p.set(k, UTM[k]); });
  return ROYALS.storeUrl + path + (path.indexOf('?') > -1 ? '&' : '?') + p.toString();
}
document.querySelectorAll('.js-utm-link').forEach(function(a){ a.href = utmUrl(a.dataset.path || ROYALS.shopAllPath); });

/* Click tracking - one delegated listener. Multi-item CTAs report as one merchandising choice. */
document.addEventListener('click', function(e){
  var el = e.target.closest('a[data-track], button[data-track]'); if(!el) return;
  var items = parseItems(el.dataset.items);
  track(el.dataset.track, {
    product: el.dataset.product || null,
    items: items.length ? serializeItems(items) : null,
    variant_ids: items.map(function(i){ return i.id; }),
    item_count: items.length || null,
    value_price: el.dataset.valuePrice ? Number(el.dataset.valuePrice) : null,
    regular_price: el.dataset.regularPrice ? Number(el.dataset.regularPrice) : null,
    royals_price: el.dataset.royalsPrice ? Number(el.dataset.royalsPrice) : null,
    position: el.dataset.position || null
  });
});
document.querySelectorAll('details[data-track]').forEach(function(d){
  d.addEventListener('toggle', function(){ if(d.open) track('faq_open', { faq: d.dataset.faq }); });
});

/* Scroll depth (25/50/75/100) + section views */
(function(){
  var marks = [25,50,75,100], hit = {};
  function onScroll(){
    var h = document.documentElement, max = h.scrollHeight - h.clientHeight;
    var pct = max > 0 ? Math.round((h.scrollTop || document.body.scrollTop) / max * 100) : 100;
    marks.forEach(function(m){ if(pct >= m && !hit[m]){ hit[m] = 1; track('scroll_depth', { percent: m }); } });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  if ('IntersectionObserver' in window){
    var seen = {};
    var io = new IntersectionObserver(function(es){
      es.forEach(function(en){ var s = en.target.dataset.section; if(en.isIntersecting && !seen[s]){ seen[s] = 1; track('section_view', { section: s }); } });
    }, { threshold: .4 });
    document.querySelectorAll('[data-section]').forEach(function(s){ io.observe(s); });
  }
})();

/* Sticky mobile CTA: on after the hero leaves, off while the product cards, email form, or final CTA are on screen */
(function(){
  var bar = document.getElementById('sticky');
  if (bar) document.body.classList.add('rl-has-sticky');
  if (!bar) return;
  var hasIO = 'IntersectionObserver' in window;
  var vis = { hero: true, shop: false, email: false, final: false };
  function upd(){
    var bag = bar.classList.contains('is-bag');
    var on = bag || (hasIO && !vis.hero && !vis.shop && !vis.email && !vis.final);
    bar.classList.toggle('show', on);
    bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    Array.prototype.forEach.call(bar.querySelectorAll('a, button'), function(el){
      var inBag = !!el.closest('.s-bag');
      el.tabIndex = (on && inBag === bag) ? 0 : -1;
    });
  }
  window.addEventListener('royals:bag', upd);
  upd();
  if (!hasIO) return;
  [['hero','.hero'],['shop','.choices'],['email','.email-capture'],['final','.final']].forEach(function(p){
    var el = document.querySelector(p[1]); if(!el) return;
    new IntersectionObserver(function(e){ vis[p[0]] = e[0].isIntersecting; upd(); }).observe(el);
  });
})();

/* ============================================================
   EMAIL CAPTURE -> Klaviyo (public client-side endpoints only)
   Public API Key + List ID come from the section's Theme Editor settings
   (data attributes on the form). No private keys, ever.
   1) POST /client/profiles       -> profile properties: source, campaign, utm_*
   2) POST /client/subscriptions  -> email marketing consent SUBSCRIBED + add to LIST
      (Added to List -> Reading Royals 2026-27 triggers the Royals 20% flow)
   Success is shown only after the subscription call returns 202.
   ============================================================ */
var KLAVIYO_REVISION = '2026-07-15';
var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
function klaviyoPost(path, key, body){
  return fetch('https://a.klaviyo.com/client/' + path + '?company_id=' + encodeURIComponent(key), {
    method: 'POST',
    headers: { 'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': KLAVIYO_REVISION },
    body: JSON.stringify(body)
  }).then(function(r){ if (r.status !== 202 && !r.ok) throw new Error('Klaviyo ' + r.status); return r; });
}
function initEmailForm(f){
  if (!f || f.dataset.bound) return;
  f.dataset.bound = '1';
  var root = f.closest('.ec-wrap') || f.parentNode;
  var inp = f.querySelector('input[type=email]'), err = f.querySelector('.err'),
      btn = f.querySelector('button[type=submit]'), done = root.querySelector('.ec-done');
  var label = btn.firstChild.textContent;
  var key = f.dataset.klaviyoKey || '', list = f.dataset.klaviyoList || '';
  ['utm_source','utm_medium','utm_campaign','utm_content'].forEach(function(k){ if (f.elements[k]) f.elements[k].value = UTM[k]; });

  function showErr(msg){ err.textContent = msg; err.hidden = false; inp.setAttribute('aria-invalid','true'); inp.focus(); }
  inp.addEventListener('input', function(){ if(!err.hidden){ err.hidden = true; inp.removeAttribute('aria-invalid'); } });

  f.addEventListener('submit', function(e){
    e.preventDefault();
    if (btn.disabled) return;
    var email = inp.value.trim();
    if (!email){ showErr('Enter your email address.'); return; }
    if (!EMAIL_RE.test(email)){ showErr('That email doesn\'t look right. Try something like you@email.com.'); return; }
    if (f.dataset.configured !== 'true' || !key || !list){ showErr('Klaviyo setup required: add Public API Key and List ID in the Theme Editor.'); return; }
    inp.removeAttribute('aria-invalid'); err.hidden = true;
    var props = {
      source: f.elements.source.value,
      campaign: f.elements.campaign.value,
      royals_season: f.elements.royals_season ? f.elements.royals_season.value : '',
      utm_source: UTM.utm_source, utm_medium: UTM.utm_medium,
      utm_campaign: UTM.utm_campaign, utm_content: UTM.utm_content
    };
    btn.disabled = true; btn.setAttribute('aria-busy','true'); btn.firstChild.textContent = 'Sending... ';
    klaviyoPost('profiles', key, { data: { type: 'profile', attributes: { email: email, properties: props } } })
      .catch(function(){ /* properties are secondary; the subscription is what counts */ })
      .then(function(){
        return klaviyoPost('subscriptions', key, { data: {
          type: 'subscription',
          attributes: { profile: { data: { type: 'profile', attributes: {
            email: email,
            subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
          } } } },
          relationships: { list: { data: { type: 'list', id: list } } }
        } });
      })
      .then(function(){
        f.hidden = true; done.hidden = false; done.focus();
        track('email_submit', { source: props.source, utm_content: UTM.utm_content });
      })
      .catch(function(){
        btn.disabled = false; btn.removeAttribute('aria-busy'); btn.firstChild.textContent = label;
        showErr('Something went wrong. Try again.');
      });
  });
}
document.querySelectorAll('.js-royals-email-form').forEach(initEmailForm);
document.addEventListener('shopify:section:load', function(){
  document.querySelectorAll('.js-royals-email-form').forEach(initEmailForm);
  refreshCartLinks();
});

})();
